// extracted by mini-css-extract-plugin
export default {"content":"DigitalResourceCard_content__JyGK2","date":"DigitalResourceCard_date__621Nw"};